<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="user-edit content-wrapper">
      <div class="page-header">{{ $t('editUser') }}</div>
      <div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/user' }">{{ $t('userList') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editUser') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px;">
        <el-form-item :label="$t('username')" :required="true">
          <el-input v-model="user.username" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('firstName')">
          <el-input v-model="user.firstName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lastName')">
          <el-input v-model="user.lastName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('email')" :required="true">
          <el-input v-model="user.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="user.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="onUpdateUserButtonClick">{{ $t('update') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/User/Edit.i18n'
import UserApi from '@/api/user-api'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent.vue'

export default {
  name: 'UserEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  props: {
    user: {
      type: Object,
      default: function () {
        return {
          id: '',
          username: '',
          firstName: '',
          lastName: '',
          email: '',
          isEnable: STATUS.ENABLE
        }
      }
    }
  },
  data () {
    return {
      STATUS,
      isLoading: true
    }
  },
  created: function () {
    this.isLoading = true

    if (this.user.id === undefined || this.user.id === '') {
      this.$router.push({
        name: 'UserList'
      })
    }

    this.isLoading = false
  },
  methods: {
    onUpdateUserButtonClick: async function () {
      try {
        this.startLoading()

        await UserApi.update(this.user.id, this.user)
        this.$router.push({
          name: 'UserList'
        })

        const title = this.$t('editUserSuccessTitle')
        const message = this.$t('editUserSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'UserList'
      })
    }
  }
}
</script>

<style>
  .el-form > div {
    text-align: left;
  }
</style>
